import qs from 'query-string';
import { api } from 'app/api';
import { success, failure } from 'app/actions';
import * as loginActions from 'login/loginActions';
import * as configurationActions from 'configuration/configurationActions';

const isDev = process.env.NODE_ENV === 'development';

const initialState = {
  role: null,
  user: null,
  token: null,
  error: {},
  queryParams: qs.parse(location.search.replace('?', '')),
  showReports: false,
  showReportsTRI: false,
  coordinator: false,
  isCoordinator: { permission: null, edit: null },
  cookies: '',
  userCI: false,
  canEditSchool: true,
  hasAccessToDemoSchool: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case success(configurationActions.UPLOAD):
      return { ...state, user: { ...state.user, photo: action.payload.filename } };
    case success(configurationActions.REMOVE_PHOTO):
      return { ...state, user: { ...state.user, photo: undefined } };
    case success(loginActions.CHECK_COORDINATOR_PERMISSION):
      return {
        ...state,
        isCoordinator: Number(action.payload.contents.isCoordinator.permission),
        coordinator: true,
        showReports: action.payload.contents.showReports,
        showReportsTRI: action.payload.contents.showReportsTRI,
      };
    case failure(loginActions.CHECK_COORDINATOR_PERMISSION):
      return {
        ...state,
        coordinator: initialState.coordinator,
        isCoordinator: initialState.isCoordinator,
        showReports: initialState.showReports,
        showReportsTRI: initialState.showReportsTRI,
      };
    case success(loginActions.LOGIN):
    case success(loginActions.EXTERNAL_AUTH):
    case success(loginActions.AUTH): {
      const { token, user, cookieToken, userCi } = action.payload;
      api.defaults.headers.common['X-Auth-Token'] = token;
      if (isDev) {
        localStorage.setItem('X-Auth-Token', token);
        localStorage.setItem('X-Token', cookieToken);
      }
      const role = parseInt(user.idType, 0);
      const userCI = !user && userCi !== null ? true : false;
      return {
        ...state,
        user,
        userCI,
        token,
        cookieToken,
        role,
        authorizing: false,
        // Usuarios de escola cadastrados no Passaporte não podem editar
        // informações controlados pelo Passaporte, como a própria escola,
        // turma, alunos.
        // Essa flag é usada para desabilitar os botões e componentes de edição
        // dessas informações.
        canEditSchool: !user.schoolIsPassaporte,
        // SA-1860
        hasAccessToDemoSchool: user.hasAccessToDemoSchool,
        error: { ...state.error, login: undefined },
      };
    }
    case failure(loginActions.LOGIN):
      return {
        ...state,
        authorizing: false,
        error: {
          ...state.error,
          login: {
            status: action.status,
            loginErrorAttempts: action.payload.error.loginErrorAttempts,
            message: action.payload.error.message,
            isUserCi: action.payload.error.isUserCi,
            passwordExpired: action.payload.error.passwordExpired,
          },
        },
      };
    case success(loginActions.MANAGE_COOKIES):
      return {
        ...state,
        // isLoading: false,
        cookies: action.payload.success,
      };
    default:
      return state;
  }
};

export default reducer;
